<template>
  <div class="user-membership-form">
    <el-form
            ref="invitationForm"
            :inline="true"
            :model="formData"
            :rules="rules"
            label-width="150px"
            label-position="top"
            v-loading="creating"
    >
      <el-tabs v-model="activeName">
        <el-tab-pane label="Existing" name="first">
          <el-form-item label="Existing User" prop="user_id">
            <el-select v-model.lazy.trim="formData.user_id" placeholder="Select user">
              <el-option
                      v-for="(user, index) in unsubscribedUsers"
                      :key="index"
                      :label="user.email"
                      :value="user.id.toString()">
              </el-option>
            </el-select>
            <p>If user is not listed, please go to the Users menu and add a new user there or click the "New" tab above.</p>
          </el-form-item>
        </el-tab-pane>
        <el-tab-pane label="New" name="second">
          <el-form-item label="New User" prop="invitation_email">
            <el-input type="email" v-model.lazy.trim="formData.invitation_email" placeholder="User email"></el-input>
          </el-form-item>
        </el-tab-pane>
      </el-tabs>      

      <el-row>
        <el-col>
          <el-form-item label="User Role" prop="role_id">
            <el-select v-model.lazy.trim="formData.role_id" placeholder="Select role">
              <el-option
                      v-for="(role, index) in app.roles"
                      :key="index"
                      :label="role.name"
                      :value="role.id.toString()">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item>
        <el-button type="primary" @click="submitForm('invitationForm')">Send Invite</el-button>
      </el-form-item>

    </el-form>
  </div>
</template>

<script>
  import { map, includes } from 'lodash';
  import { mapGetters } from 'vuex';

  import validations from '@/utils/validations';
  import { showSuccessMessage, showErrorMessage } from '@/ui/message';

  export default {
    name: 'UserMembershipForm',
    props: {
      app: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        activeName: 'first',
        rules: {
          invitation_email: [
            { ...validations.email },
          ],
          role_id: [
            { ...validations.required },
          ],
        },
        userId: (this.$router.currentRoute.query.userId) ? this.$router.currentRoute.query.userId.toString() : null,
        formData: {
          user_id: this.userId || '',
          invitation_email: '',
          role_id: '',
        },
      };
    },
    computed: {
      ...mapGetters('entities/userMemberships', ['creating']),

      unsubscribedUsers() {
        const existingEmails = map(this.app.user_memberships, 'invitation_email');

        return this.$store.getters['entities/users/query']()
          .where('admin', false)
          .where('email', email => !includes(existingEmails, email))
          .get();
      },
    },
    methods: {
      submitForm(formName) {
        if (this.formData.invitation_email === '' && this.formData.user_id === '') {
          showErrorMessage('Please either select existing user or provide email of new user.');
        } else {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.$store.dispatch('entities/userMemberships/inviteUser', { appId: this.app.id, data: this.formData })
                .then((response) => {
                  if (response.status) {
                    showSuccessMessage('Invitation email has been sent to the user.');
                    this.$refs[formName].resetFields();
                  } else {
                    showErrorMessage(response.error);
                  }
                });
            } else {
              showErrorMessage(this.$t('form.messages.notValid'));

              return false;
            }

            return true;
          });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .user-membership-form {
    .fields-separator {
      padding: 8px 30px;
      display: inline-block;
    }
  }
  p{
    margin: 10px 0 0;
    line-height: 1.5em;
  }
</style>


// WEBPACK FOOTER //
// src/components/userMembership/UserMembershipForm.vue